import CategoryFilterRecursion from './CategoryFilterRecursion';
import { FilterAside, FilterList, FilterSection } from './styled';

export default function CategoryFilter(props) {
  const { categoryFilterData } = props;

  return categoryFilterData?.length ? (
    <FilterAside>
      <FilterSection>
        <FilterList>
          {categoryFilterData.map((item, index) => {
            return (
              <CategoryFilterRecursion
                data={item}
                index={index}
                key={`filter_${index}`}
              />
            );
          })}
        </FilterList>
      </FilterSection>
    </FilterAside>
  ) : null;
}
